/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * sub-methods for paymentTypes, CASH,CARD,TRANSFER are generic payment methods for the types cash and card in the new system, EVERY_PAY is a specific method with type of TRANSFER
 */
export type PaymentMethodEnum = 'EVERY_PAY' | 'CASH' | 'CARD' | 'TRANSFER';

export const PaymentMethodEnum = {
    EveryPay: 'EVERY_PAY' as PaymentMethodEnum,
    Cash: 'CASH' as PaymentMethodEnum,
    Card: 'CARD' as PaymentMethodEnum,
    Transfer: 'TRANSFER' as PaymentMethodEnum
};

